/* Copyright 2011-2012 The MathWorks, Inc. */

/**
 * This defines a list of constants which represent the different components of the toolstrip.
 */

define([], function () {
    return {
        //Roots
        TOOLSTRIP_ROOT: "ToolstripRoot",
        QAB_ROOT: "QABRoot",
        POPUP_ROOT: "PopupRoot",
        GALLERY_ROOT: "GalleryRoot",
        GALLERY_POPUP_ROOT: "GalleryPopupRoot",
        GALLERY_PANEL_ROOT: "GalleryPanelRoot",
        GALLERY_FAVORITE_CATEGORY_ROOT: "GalleryFavoriteCategoryRoot",

        //Containers:
        TOOLSTRIP: "Toolstrip",
        QAB: "QuickAccessBar",
        QA_GROUP: "QuickAccessGroup",
        TAB_GROUP: "TabGroup",
        TAB: "Tab",
        SECTION: "Section",
        PANEL: "Panel",
        COLUMN: "Column",

        //Controls:
        COLOR_PICKER_BUTTON: "ColorPickerButton",
        GRID_PICKER_BUTTON: "GridPickerButton",
        PUSH_BUTTON: "PushButton",
        DROP_DOWN_BUTTON: "DropDownButton",
        SPLIT_BUTTON: "SplitButton",
        TOGGLE_BUTTON: "ToggleButton",
        POPUP_LIST: "PopupList",
        LIST_ITEM: "ListItem",
        POPUP_LIST_PANEL: "PopupListPanel",
        LIST_ITEM_WITH_CHECKBOX: "ListItemWithCheckBox",
        LIST_ITEM_WITH_TEXTFIELD: "ListItemWithTextField",
        LIST_ITEM_WITH_RADIO_BUTTON: "ListItemWithRadioButton",
        LIST_ITEM_WITH_POPUP: "ListItemWithPopup",
        POPUP_LIST_SEPARATOR: "PopupListSeparator",
        POPUP_LIST_HEADER: "PopupListHeader",
        COMBO_BOX: "ComboBox",
        LIST: "List",
        LABEL: "Label",
        EMPTY_CONTROL: "EmptyControl",
        TEXT_FIELD: "TextField",
        TEXT_AREA: "TextArea",
        SPINNER: "Spinner",
        HORIZONTAL_SLIDER: "HorizontalSlider",
        RADIO_BUTTON: "RadioButton",
        CHECK_BOX: "CheckBox",
        TOGGLE_SPLIT_BUTTON: "ToggleSplitButton",

        //Footer
        FOOTER: "Footer",
        FOOTER_CELL: "FooterCell",

        //QAB Controls:
        QAB_PUSH_BUTTON: "QABPushButton",
        QAB_DROP_DOWN_BUTTON: "QABDropDownButton",
        QAB_SPLIT_BUTTON: "QABSplitButton",
        QAB_TOGGLE_BUTTON: "QABToggleButton",
        QAB_TOGGLE_SPLIT_BUTTON: "QABToggleSplitButton",
        QAB_FLOATING_PANE_DOCK: "QABFloatingPaneDock",

        //Wrappers:
        MENUBAR_WRAPPER: "MenubarWrapper",
        TOOLBAR_WRAPPER: "ToolbarWrapper",

        //Gallery:
        GALLERY: "Gallery",
        GALLERY_POPUP: "GalleryPopup",
        GALLERY_PANEL: "GalleryPanel",
        GALLERY_CATEGORY: "GalleryCategory",
        GALLERY_FAVORITE_CATEGORY: "GalleryFavoriteCategory",
        GALLERY_ITEM: "GalleryItem",
        TOGGLE_GALLERY_ITEM: "ToggleGalleryItem"
    };
});